import { render, staticRenderFns } from "./CheckoutGroup.vue?vue&type=template&id=52a450a4"
import script from "./checkoutGroup.ts?vue&type=script&lang=ts&external"
export * from "./checkoutGroup.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52a450a4')) {
      api.createRecord('52a450a4', component.options)
    } else {
      api.reload('52a450a4', component.options)
    }
    module.hot.accept("./CheckoutGroup.vue?vue&type=template&id=52a450a4", function () {
      api.rerender('52a450a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/shared/checkout/buttons-group/groups/client/checkout-group/CheckoutGroup.vue"
export default component.exports